import { DownOutlined, FilterFilled, SearchOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Button, ButtonProps, Tooltip } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const SearchButton = styled(Button)`
  .anticon svg {
    transition: all 0.3s;
  }
`;

export interface FilterButtonProps extends Omit<ButtonProps, 'icon'> {
  /** Se true, l'icona ruota per indicare l'apertura del collapse */
  opened?: boolean;
  /** Se true, mostra un icona ruota per indicare che è attiva una ricerca
   * e si stanno visualizzando dati filtrati */
  filtered?: boolean;
}

/**
 * Button per la ricerca da posizionare come extra nel componente Tabs
 * Utilizzato per oprire il pannello con il form di ricerca (Collapse)
 */
export function FilterButton(props: FilterButtonProps) {
  const { opened, children, filtered, ...rest } = props;
  const { t } = useTranslation();

  return (
    <SearchButton {...rest}>
      {filtered ? (
        <Tooltip
          title={t(
            'collapse.filter-button.tooltip',
            'Filtri di ricerca attivi',
          )}
        >
          <FilterFilled
            aria-label={t(
              'collapse.filter-button.tooltip-aria',
              'Filtri di ricerca attivi',
            )}
          />
        </Tooltip>
      ) : (
        <SearchOutlined aria-hidden />
      )}
      {children ?? t('collapse.filter-button.content', 'Ricerca Estesa')}{' '}
      <DownOutlined aria-hidden rotate={opened ? 180 : 0} />
    </SearchButton>
  );
}
